import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useIntervalModel } from "../intervalModel";
import { IIntervalDetail } from "../intervalService";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useIntervalModel();

    useEffect(() => {
        // loadData()
    }, [])

    const columns: ColumnsType<IIntervalDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '从属门店',
            width: 160,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '仓库',
            width: 160,
            dataIndex: 'materialName',
            fixed: "left",
        }, {
            title: '开始日期',
            width: 160,
            dataIndex: 'brandName',
        }, {
            title: '结束日期',
            width: 120,
            dataIndex: 'typeName',
        }, {
            title: '期初库存金额',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '期末库存金额',
            width: 120,
            dataIndex: 'replaceCode',
        }, {
            title: '本期入库金额',
            width: 160,
            dataIndex: 'address',
        }, {
            title: '本期出库金额',
            width: 160,
            dataIndex: 'address',
        }
    ];


    // //点击行选高亮
    // const onRow = (id: string) => {
    //     if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
    //         setSelectedRowKeys([]);
    //     } else {
    //         setSelectedRowKeys([id]);
    //     }
    // };

    return (
        <Table
            rowKey={record => record.id}
            // rowSelection={{
            //     type: "radio",
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IIntervalDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys as string[]);
            //     }
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content' }}
        />
    )
}
